"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsumerVerificationStatus = exports.ConsumerStatus = void 0;

var common_1 = require("./common");

var SignUpStage;

(function (SignUpStage) {
  SignUpStage["ACCOUNT_CREATED"] = "account_created";
  SignUpStage["ADDITIONAL_INFORMATION"] = "additional_information_added";
  SignUpStage["COMPANY_CREATED"] = "company_created";
  SignUpStage["ID_VERIFICATION"] = "id_verification";
  SignUpStage["BANK_ACCOUNT_CONNECTION"] = "bank_account_connection";
  SignUpStage["FULLY_REGISTERED"] = "fully_registered";
})(SignUpStage || (SignUpStage = {}));

var ConsumerStatus;

(function (ConsumerStatus) {
  ConsumerStatus["ACTIVE"] = "active";
  ConsumerStatus["BLOCKED"] = "blocked";
  ConsumerStatus["BANNED"] = "banned";
  ConsumerStatus["DELETED"] = "deleted";
  ConsumerStatus["PENDING_VERIFICATION"] = "pending_verification";
  ConsumerStatus["REJECTED_WITH_RETRY_ALLOWED"] = "rejected_with_retry_allowed";
  ConsumerStatus["STARTED_VERIFICATION"] = "started_verification";
  ConsumerStatus["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
})(ConsumerStatus = exports.ConsumerStatus || (exports.ConsumerStatus = {}));

var ConsumerVerificationStatus;

(function (ConsumerVerificationStatus) {
  ConsumerVerificationStatus["VERIFIED"] = "verified";
  ConsumerVerificationStatus["RETRY_ALLOWED"] = "retry";
  ConsumerVerificationStatus["REJECTED"] = "rejected";
  ConsumerVerificationStatus["PENDING"] = "pending";
  ConsumerVerificationStatus["MANUAL_CHECK_REQUIRED"] = "manual_check_required";
})(ConsumerVerificationStatus = exports.ConsumerVerificationStatus || (exports.ConsumerVerificationStatus = {}));